import type { TextStyle } from "react-native";
import MarkdownDisplay from "react-native-markdown-display";
import { withUnistyles } from "react-native-unistyles";

import pickFromBreakpoints from "$src/core/utils/styling/pick-from-breakpoints";

type Props = {
  content: string;
};

const MarkdownDisplayWrapper = ({
  children,
  ...style
}: {
  body: TextStyle;
  paragraph: TextStyle;
  heading1: TextStyle;
  heading2: TextStyle;
  heading3: TextStyle;
  heading4: TextStyle;
  heading5: TextStyle;
  heading6: TextStyle;
  heading7: TextStyle;
  children: React.ReactNode;
}) => <MarkdownDisplay style={style}>{children}</MarkdownDisplay>;

const UniMarkdownDisplay = withUnistyles(
  MarkdownDisplayWrapper,
  ({ font, colors, spacing }, { breakpoint }) => ({
    body: {
      color: colors.foregroundDefault,
    },
    paragraph: {
      marginBottom: spacing(6),
      fontFamily: font.families.body,
      fontSize: pickFromBreakpoints(font.sizes.body, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.body, breakpoint),
    },
    heading1: {
      marginBottom: spacing(4),
      fontFamily: font.families.heading1,
      fontSize: pickFromBreakpoints(font.sizes.heading1, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading1, breakpoint),
    },
    heading2: {
      marginBottom: spacing(4),
      fontFamily: font.families.heading2,
      fontSize: pickFromBreakpoints(font.sizes.heading2, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading2, breakpoint),
    },
    heading3: {
      marginBottom: spacing(2),
      fontFamily: font.families.heading3,
      fontSize: pickFromBreakpoints(font.sizes.heading3, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading3, breakpoint),
    },
    heading4: {
      marginBottom: spacing(2),
      fontFamily: font.families.heading4,
      fontSize: pickFromBreakpoints(font.sizes.heading4, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading4, breakpoint),
    },
    heading5: {
      fontFamily: font.families.heading5,
      fontSize: pickFromBreakpoints(font.sizes.heading5, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading5, breakpoint),
    },
    heading6: {
      fontFamily: font.families.heading6,
      fontSize: pickFromBreakpoints(font.sizes.heading6, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading6, breakpoint),
    },
    heading7: {
      fontFamily: font.families.heading7,
      fontSize: pickFromBreakpoints(font.sizes.heading7, breakpoint),
      lineHeight: pickFromBreakpoints(font.lineHeights.heading7, breakpoint),
    },
  }),
);

const Markdown = ({ content }: Props) => (
  <UniMarkdownDisplay>{content}</UniMarkdownDisplay>
);

export default Markdown;
